var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapNavigationAddress"},_vm._l((_vm.items),function(item,index){return _c('navigation-address-item',{key:index,attrs:{"index":index,"item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }